export default "__VITE_ASSET__CxlP83j9__"